// large tooltip width
const TOOLTIP_WIDTH = 250;

export const getTooltipDirection = ({
    x,
    y,
    containerWidth,
}: {
    x: number;
    y: number;
    containerWidth: number | undefined;
}): 'top' | 'right' | 'bottom' | 'left' => {
    const tooltipHalfWidth = TOOLTIP_WIDTH / 2;

    // returns default direction if no parent container width is not provided
    if (!containerWidth) {
        return 'top';
    }

    const triggerOffsetLeft = (containerWidth * x) / 100;
    const triggerOffsetRight = containerWidth - triggerOffsetLeft;

    // if tooltip is too close to the right (less than half width of tooltip) direction should be left
    if (triggerOffsetRight < tooltipHalfWidth) {
        return 'left';
    }

    // if tooltip is too close to the left (less than half width of tooltip) direction should be right
    if (triggerOffsetLeft < tooltipHalfWidth) {
        return 'right';
    }

    // if tooltip trigger is below middle direction should be top, if trigger is above middle - direction should be bottom
    if (y < 50) {
        return 'bottom';
    } else {
        return 'top';
    }
};
